module.exports = __webpack_public_path__ + "img/oil_painting_human.6b692e6a.jpeg";